import { render, staticRenderFns } from "./pagedtable.vue?vue&type=template&id=5c09150c&"
import script from "./pagedtable.vue?vue&type=script&lang=js&"
export * from "./pagedtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports